/** Icons for the batch crop browser — a macOS-style folder and a PDF document. */

let uid = 0;
const nextId = () => `ic${++uid}`;

export function FolderIcon({ className = "" }: { className?: string }) {
  // Gradient ids must be unique per instance or repeated icons share a def.
  const back = nextId();
  const front = nextId();
  return (
    <svg viewBox="0 0 64 52" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={back} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5AACE6" />
          <stop offset="100%" stopColor="#2E80C6" />
        </linearGradient>
        <linearGradient id={front} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8FD0F5" />
          <stop offset="100%" stopColor="#4EA5E4" />
        </linearGradient>
      </defs>
      {/* Back panel with the tab */}
      <path
        d="M2 11a5 5 0 0 1 5-5h16.2a3 3 0 0 1 2.1.9l4.3 4.2a3 3 0 0 0 2.1.9H57a5 5 0 0 1 5 5v29a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5z"
        fill={`url(#${back})`}
      />
      {/* Front panel, slightly lighter and inset like Finder */}
      <path
        d="M2 20h60v25a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5z"
        fill={`url(#${front})`}
      />
      <path d="M2 20h60v1.5H2z" fill="#FFFFFF" opacity="0.35" />
    </svg>
  );
}

export function PdfIcon({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 48" className={className} aria-hidden="true">
      <path
        d="M4 4a3 3 0 0 1 3-3h17.5L36 12.5V44a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
        fill="#EDF1F5"
      />
      {/* Folded corner */}
      <path d="M24.5 1L36 12.5h-8.5a3 3 0 0 1-3-3z" fill="#B9C4D0" />
      <rect x="3" y="25" width="26" height="12" rx="2.5" fill="#E5443B" />
      <text
        x="16"
        y="33.6"
        textAnchor="middle"
        fontSize="8.5"
        fontWeight="700"
        fill="#FFFFFF"
        fontFamily="Helvetica, Arial, sans-serif"
      >
        PDF
      </text>
    </svg>
  );
}

export function ImageIcon({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 40 48" className={className} aria-hidden="true">
      <path
        d="M4 4a3 3 0 0 1 3-3h17.5L36 12.5V44a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
        fill="#EDF1F5"
      />
      <path d="M24.5 1L36 12.5h-8.5a3 3 0 0 1-3-3z" fill="#B9C4D0" />
      <rect x="8" y="21" width="24" height="17" rx="2" fill="#3FAE6B" />
      <circle cx="14.5" cy="27" r="2.2" fill="#FFFFFF" opacity="0.9" />
      <path d="M8 34.5l6.5-6 5.5 5 4.5-4L32 35v1a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z" fill="#2C8A52" />
    </svg>
  );
}
